import "./index.scss";
import React, { CSSProperties, ReactNode } from "react";
import cn from "classnames";

export type StickyElementProps = {
  title: string;
  price?: string;
  description?: string;
  cta: ReactNode;
  isContrast?: boolean;
  theme?:
    | "base-primary"
    | "brand-secondary"
    | "inverse-base-primary"
    | "brand-gradient";
};

export const StickyElement = ({
  title,
  price,
  description,
  cta,
  isContrast,
  theme = "base-primary",
}: StickyElementProps) => (
  <div className="sticky-element">
    <div
      style={
        {
          "--sticky-element-background":
            theme !== "brand-gradient"
              ? `var(--background-${theme})`
              : undefined,
        } as CSSProperties
      }
      className={cn("sticky-element__core", {
        "sticky-element__core--gradient": theme === "brand-gradient",
        "sticky-element__core--contrast": isContrast,
      })}
    >
      <div className="wrapContent wrapContent-xl-lg wrapContent-lg-lg wrapContent-md-lg sticky-element__wrapper">
        <div className="sticky-element__left-content">
          <h3 className="sticky-element__title">{title}</h3>
          <div className="sticky-element__left-content__price-box">
            {price && <span className="sticky-element__price">{price}</span>}
            {description && (
              <p className="sticky-element__description">{description}</p>
            )}
          </div>
        </div>
        <div className="sticky-element__right-content">{cta}</div>
      </div>
    </div>
  </div>
);

StickyElement.displayName = "StickyElement";
